export const BUSINESS = {
  name: "Shri Bala Ji Computer & Mobile Solution",
  shortName: "Shri Bala Ji",
  tagline: "Professional Computer & Mobile Repair Experts",
  phone: "7668032269",
  phoneIntl: "+917668032269",
  whatsapp: "917668032269", // digits only for wa.me
  email: "shribalajirepairlab@gmail.com",
  hours: "8:00 AM – 9:00 PM (All days)",
  address: {
    line1: "Sherwa Chauraha, Aghwanpur",
    line2: "In Front of St. Mary's School",
    city: "Moradabad",
    state: "Uttar Pradesh",
    country: "India",
  },
  mapsQuery:
    "Shri+Bala+Ji+Computer+%26+Mobile+Solution+Sherwa+Chauraha+Aghwanpur+In+Front+of+St+Mary's+School+Moradabad",
};

export const SALE = [
  { title: "Mobile Phones", icon: "fa-solid fa-mobile-screen", desc: "Latest smartphones from trusted brands." },
  { title: "Computers", icon: "fa-solid fa-desktop", desc: "Custom-built desktops & branded PCs." },
  { title: "Laptops", icon: "fa-solid fa-laptop", desc: "Business, gaming & everyday laptops." },
  { title: "Accessories", icon: "fa-solid fa-headphones", desc: "Chargers, cables, cases, audio & more." },
];

export const PURCHASE = [
  { title: "Old Mobile Purchase", icon: "fa-solid fa-hand-holding-dollar", desc: "Best cash value for your used mobile." },
  { title: "Used Laptop Purchase", icon: "fa-solid fa-laptop-medical", desc: "Instant quote & fair buy-back offers." },
  { title: "Computer Purchase", icon: "fa-solid fa-computer", desc: "We buy working desktops & parts." },
  { title: "Device Exchange", icon: "fa-solid fa-arrows-rotate", desc: "Trade old for new — hassle-free." },
];

export const REPAIRS = [
  { title: "Mobile Repair", icon: "fa-solid fa-mobile-screen-button", desc: "All brands — display, charging, mic, speaker." },
  { title: "Computer Repair", icon: "fa-solid fa-computer", desc: "Boot issues, overheating, PSU & more." },
  { title: "Laptop Repair", icon: "fa-solid fa-laptop", desc: "Hinge, keyboard, trackpad, cooling repairs." },
  { title: "Hardware Repair", icon: "fa-solid fa-microchip", desc: "Chip-level & board-level diagnostics." },
  { title: "Software Installation", icon: "fa-solid fa-download", desc: "Genuine apps & driver setup." },
  { title: "Windows Installation", icon: "fa-brands fa-windows", desc: "Fresh Windows install with activation." },
  { title: "Virus Removal", icon: "fa-solid fa-shield-virus", desc: "Deep-clean malware & ransomware." },
  { title: "Motherboard Repair", icon: "fa-solid fa-memory", desc: "Precision SMD & reballing work." },
  { title: "Screen Replacement", icon: "fa-solid fa-square-caret-down", desc: "Original-grade displays for phones & laptops." },
  { title: "Battery Replacement", icon: "fa-solid fa-battery-full", desc: "High-quality certified batteries." },
  { title: "Data Recovery", icon: "fa-solid fa-hard-drive", desc: "Rescue photos, docs & drives." },
  { title: "SSD Upgrade", icon: "fa-solid fa-bolt", desc: "5x faster boot & load times." },
  { title: "RAM Upgrade", icon: "fa-solid fa-layer-group", desc: "Smoother multitasking, more power." },
];

export const ALL_SERVICE_NAMES = [
  ...SALE.map((s) => s.title),
  ...PURCHASE.map((s) => s.title),
  ...REPAIRS.map((s) => s.title),
];
